import AvtaleGiroView from '@/views/AvtaleGiro/AvtaleGiroView.vue'
import CheckoutView from '@/views/CheckoutView.vue'
import InvoiceView from '@/views/InvoiceView/InvoiceView.vue'
import { h } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'blank-page',
      // TODO: Create a proper page here, maybe redirect to paybucky.com??

      component: () => h('div', { class: 'flex items-center justify-center h-screen' }, []),
    },
    {
      path: '/:paymentReferenceID',
      name: 'payment',
      children: [
        {
          path: '',
          name: 'checkout',
          component: CheckoutView,
        },
        {
          path: 'verifying-payment',
          name: 'verifying-payment',
          redirect: ({ params }) => ({
            name: 'checkout',
            params: { paymentReferenceID: params.paymentReferenceID },
            query: { view: 'verifying-payment' },
          }),
        },
        {
          path: 'view/:view',
          name: 'payment-view',
          redirect: ({ params }) => ({
            name: 'checkout',
            params: { paymentReferenceID: params.paymentReferenceID },
            query: { view: params.view },
          }),
        },
        {
          path: 'invoice',
          name: 'invoice',
          children: [
            {
              path: '',
              name: 'invoice-view',
              component: InvoiceView,
            },
            {
              path: 'creditnote',
              name: 'creditnote',
              component: () => import('@/views/InvoiceView/CreditNoteView.vue'),
            },
          ],
        },
        {
          path: 'notices/:paymentNotificationID',
          name: 'notice',
          component: () =>
            import('@/views/InvoiceView/PaymentNotifications/PaymentNotificationView.vue'),
        },
      ],
    },
    {
      path: '/avtalegiro/:avtaleGiroOnboardingLinkID',
      name: 'avtalegiro',
      children: [
        {
          path: '',
          name: 'avtalegiro-view',
          component: AvtaleGiroView,
        },
      ],
    },
  ],
})

export default router
